import React from "react";

import { SidebarMenuItemType } from "../../../services/helpers/types";
import { CurrentSidebarItemState } from "../../pages/MainPage/MainPage";
import { Add } from "@mui/icons-material";
import Button from "../../atoms/Button/Button";
import { useDispatch } from "react-redux";
import {
  CreateItemBody,
  createNewDiagnosis,
} from "../../../services/api/sidebar.api";
import DraggableSidebarList from "../../atoms/DraggableSidebarList/DraggableSidebarList";
import { getMaxPosition } from "../../../services/helpers/commonHelpers";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store/store";
import { useTranslation } from "react-i18next";

interface EditableSidebarItemsProps {
  sidebarItems: SidebarMenuItemType[];
  currentSidebarItem: CurrentSidebarItemState;
  onPageSelect: (itemID?: number, shouldRefresh?: boolean) => void;
  onPageCreate: (itemID: number) => void;
}

const EditableSidebarItems = (props: EditableSidebarItemsProps) => {
  const { sidebarItems, currentSidebarItem, onPageSelect, onPageCreate } =
    props;

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const userID = useSelector(
    (state: RootState) => state.settings?.user?.userID,
  );

  const handleCreateNewDiagnosis = () => {
    if (userID) {
      const maxPosition = getMaxPosition(sidebarItems);

      const body: CreateItemBody = {
        position: maxPosition + 1,
        name: t("newDiagnosisItem"),
        tab1Name: t("newTabItemSubjective"),
        tab1Value: t("newTabItemSubjectiveValue"),
        tab2Name: t("newTabItemObjective"),
        tab2Value: t("newTabItemObjectiveValue"),
      };

      createNewDiagnosis(dispatch, body).then((response) => {
        if (response !== undefined && response.length > 0) {
          onPageCreate(response[0].sidebarItemID);
        }
      });
    }
  };
  return (
    <div className="dui-sidebar-edit-items-wrapper">
      <DraggableSidebarList
        sidebarItems={sidebarItems}
        currentSidebarItem={currentSidebarItem.item}
        onPageChange={onPageSelect}
      />
      <div className="dui-sidebar-edit-add" onClick={handleCreateNewDiagnosis}>
        <Button
          icon={<Add />}
          type="primary"
          corners="circle"
          className="dui-sidebar-edit-add-button"
        />
      </div>
    </div>
  );
};

export default EditableSidebarItems;
